module.exports = __webpack_public_path__ + "img/btn/button-secondary-normal@2x.png";


//////////////////
// WEBPACK FOOTER
// ./img/btn/button-secondary-normal@2x.png
// module id = 52
// module chunks = d-game